// import { useEffect, useRef, useState, useCallback, useMemo } from "react";
// import { format, isToday, isYesterday } from "date-fns";
// import { SendHorizonal, ArrowDownCircle, RefreshCcw, Link2, Trash2, Plus } from "lucide-react";
// import useAxiosInstance from "../../helpers/useAxiosInstance";
// import { debounce } from "lodash";
// import { getDisplayName } from "../../utils/message.utils";


// const SkeletonLoader = () => (
//   <div className="flex justify-start mb-3">
//     <div className="bg-gray-300 animate-pulse rounded-3xl px-6 py-3 w-1/2 h-4" />
//   </div>
// );

// const smoothScrollBy = (element, delta, duration = 1) => {
//   const start = element.scrollTop;
//   const startTime = performance.now();

//   const animate = (currentTime) => {
//     const elapsed = currentTime - startTime;
//     const progress = Math.min(elapsed / duration, 1);
//     const ease = 0.5 * (1 - Math.cos(Math.PI * progress)); // ease-in-out

//     element.scrollTop = start + delta * ease;

//     if (progress < 1) {
//       requestAnimationFrame(animate);
//     }
//   };

//   requestAnimationFrame(animate);
// };

// const MessagesPane = ({ contact }) => {
//   const [messages, setMessages] = useState([]);
//   const [nextCursor, setNextCursor] = useState(null);
//   const [hasMore, setHasMore] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [client, setClient] = useState(null);
//   const [showScrollToBottom, setShowScrollToBottom] = useState(false);
//   const [showNewMessage, setShowNewMessage] = useState(false);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [isTourModalOpen, setIsTourModalOpen] = useState(false)

//   const axiosInstance = useAxiosInstance();
//   const scrollRef = useRef(null);
//   const topMessageRef = useRef(null);
//   const observerRef = useRef(null);

//   const scrollToBottom = () => {
//     scrollRef.current?.scrollTo({
//       top: scrollRef.current.scrollHeight,
//       behavior: "smooth",
//     });
//     setShowNewMessage(false);
//   };

//   const fetchMessages = useCallback(
//     async (cursor = null, replace = false) => {
//       if (!contact?.thread_id || loading || (!replace && !hasMore)) return;

//       setLoading(true);
//       setErrorMessage("");

//       try {
//         const res = await axiosInstance.get(
//           `${process.env.REACT_APP_API_URL}/messages/list`,
//           {
//             params: {
//               threadId: contact.thread_id,
//               limit: 20,
//               cursor: cursor ?? undefined,
//             },
//           }
//         );

//         const newMessages = (res.data?.data || []).reverse();
//         const newCursor = res.data?.pagination?.nextCursor ?? null;
//         const more = res.data?.pagination?.hasMore ?? false;

//         setMessages((prev) => {
//           const existingIds = new Set(prev.map((m) => m.message_id));
//           const uniqueNew = newMessages.filter(
//             (msg) => !existingIds.has(msg.message_id)
//           );
//           return replace ? uniqueNew : [...uniqueNew, ...prev];
//         });

//         setNextCursor(newCursor);
//         setHasMore(more);
//       } catch (err) {
//         console.error("Fetch messages error:", err);
//         setErrorMessage("Failed to load messages. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     },
//     [contact?.thread_id, axiosInstance, hasMore, loading]
//   );

//   // Debounce fetch to prevent rapid multiple calls
//   const debouncedFetchMessages = useMemo(
//     () =>
//       debounce(
//         (
//           cursor,
//           replace = false,
//           container = null,
//           topEl = null,
//           oldTopOffset = 0
//         ) => {
//           fetchMessages(cursor, replace).then(() => {
//             if (replace) {
//               setTimeout(() => {
//                 scrollRef.current?.scrollTo({
//                   top: scrollRef.current.scrollHeight,
//                   behavior: "smooth",
//                 });
//               }, 0);
//             } else if (oldTopOffset > 0 && topMessageRef?.current) {
//               setTimeout(() => {
//                 const newTopOffset = topEl?.offsetTop;
//                 const scrollAdjustment = newTopOffset - oldTopOffset;
//                 smoothScrollBy(container, scrollAdjustment);
//               }, 0);
//             }
//           });
//         },
//         1000
//       ),
//     [fetchMessages, topMessageRef, smoothScrollBy]
//   );

//   useEffect(() => {
//     if (!contact?.thread_id) return;

//     setMessages([]);
//     setNextCursor(null);
//     setHasMore(true);
//     setClient(contact?.client || null);

//     debouncedFetchMessages(null, true);
//   }, [contact]);

//   const isNearBottom = () => {
//     const el = scrollRef.current;
//     if (!el) return false;
//     return el.scrollHeight - el.scrollTop - el.clientHeight < 200;
//   };

//   const handleRefresh = async () => {
//     const shouldScroll = isNearBottom();
//     setErrorMessage("");
//     setMessages([]);
//     setNextCursor(null);
//     setHasMore(true);
//     setShowScrollToBottom(false);
//     try {
//       debouncedFetchMessages(null, true);

//     } catch (err) {
//       setErrorMessage("Failed to refresh messages.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     scrollRef.current?.scrollTo({
//       top: 50,
//       behavior: "smooth",
//     });
//     const container = scrollRef.current;
//     const topEl = topMessageRef.current;

//     if (!container || !topEl || loading || !hasMore || !nextCursor) return;

//     const oldTopOffset = topEl.offsetTop;

//     const observer = new IntersectionObserver(

//       (entries) => {
//         const entry = entries[0];
//         if (entry.isIntersecting && nextCursor) {
//           console.log("Called");
//           // Fetch and preserve scroll position
//           debouncedFetchMessages(
//             nextCursor,
//             false,
//             container,
//             topEl,
//             oldTopOffset
//           );

//         }
//       },
//       {
//         root: container,
//         threshold: 1.0,
//       }
//     );

//     observer.observe(topEl);
//     observerRef.current = observer;

//     return () => observerRef.current.disconnect();
//   }, [messages, nextCursor, hasMore, loading]);

//   useEffect(() => {
//     const container = scrollRef.current;
//     if (!container) return;

//     const handleScroll = () => {
//       const distanceFromBottom =
//         container.scrollHeight - container.scrollTop - container.clientHeight;
//       setShowScrollToBottom(distanceFromBottom > 300);
//     };

//     container.addEventListener("scroll", handleScroll);
//     return () => container.removeEventListener("scroll", handleScroll);
//   }, []);

//   useEffect(() => {
//     const el = scrollRef.current;
//     if (!el) return;

//     const isNearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 200;

//     if (!isNearBottom) {
//       //setShowNewMessage(true);
//     } else {
//       //setShowNewMessage(false);
//       scrollToBottom();
//     }
//   }, [messages.length]);

//   const handleTextClick = (phoneNumber, name = "") => {
//     const message = ``.trim();
//     window.open(`sms:${phoneNumber}?body=${encodeURIComponent(message)}`);
//   };

//   const formatDateLabel = (timestamp) => {
//     const date = new Date(timestamp);
//     if (isToday(date)) return "Today";
//     if (isYesterday(date)) return "Yesterday";
//     return format(date, "MMM dd, yyyy");
//   };

//   const formatTime = (timestamp) => format(new Date(timestamp), "hh:mm a");

//   // const grouped = messages.reduce((acc, msg) => {
//   //   const label = formatDateLabel(msg.timestamp);
//   //   if (!acc[label]) acc[label] = [];
//   //   acc[label].push(msg);
//   //   return acc;
//   // }, {});

//   // const groupedArray = Object.entries(grouped);

//   const grouped = useMemo(
//     () =>
//       messages.reduce((acc, msg) => {
//         const dateLabel = formatDateLabel(msg.timestamp);
//         if (!acc[dateLabel]) acc[dateLabel] = [];
//         acc[dateLabel].push(msg);
//         return acc;
//       }, {}),
//     [messages]
//   );
//   const groupedArray = useMemo(() => Object.entries(grouped), [grouped]);

//   return (
//     <div className="flex flex-col flex-1 bg-gray-100 relative">
//       {/* Header */}
//       <div className="bg-white border-b px-6 py-3 shadow-sm font-semibold flex justify-between items-center">
//         <div>
//           {getDisplayName(client, contact?.participants ?? [], contact?.contact)}  {contact?.participants?.at(0) && `(${contact?.participants?.at(0)})`}  
//         </div>
//         <div className="flex gap-2">
//           <button
//             className="flex items-center gap-1 px-2 py-1 border border-blue-500 text-blue-600 hover:text-white hover:bg-blue-500 rounded text-sm"
//             title="Property"
//             onClick={()=>{
//               setIsTourModalOpen(true)
//               }
//             }
//           >
//             <Link2 size={16} />
//             Link Toured Property
//           </button>
//           <button
//             onClick={() => {
//               handleRefresh();
//             }}
//             disabled={loading}
//             className="flex items-center gap-1 px-2 py-1 border border-blue-500 text-blue-600 hover:text-white hover:bg-blue-500 rounded text-sm"
//             title="Refresh"
//           >
//             <RefreshCcw size={16} />
//           </button>
//           <button
//             onClick={() =>
//               handleTextClick(contact?.participants?.[0], client?.firstname)
//             }
//             className="flex items-center gap-1 px-2 py-1 border border-blue-500 text-blue-600 hover:text-white hover:bg-blue-500 rounded text-sm"
//           >
//             <SendHorizonal size={16} />
//           </button>
//         </div>
//       </div>

//       {/* Tour Links Modal */}
//       <TourLinksModal
//         threadId={contact?.thread_id}
//         isOpen={isTourModalOpen}
//         onClose={() => setIsTourModalOpen(false)}
//         axiosInstance={axiosInstance}
//       />

//       {/* Message List */}
//       <div
//         ref={scrollRef}
//         className="flex-1 overflow-y-auto px-4 py-2 space-y-4 relative"
//       >
//         {/* <div ref={topMessageRef} className="h-1" /> */}

//         {errorMessage && (
//           <div className="text-red-600 text-sm text-center py-2">
//             {errorMessage}
//           </div>
//         )}

//         {loading && messages.length === 0 && (
//           <div className="absolute inset-0 bg-white/70 backdrop-blur-sm z-10">
//             {/* loader inside */}

//             <div className="flex flex-col flex-1 justify-center items-center py-10 space-y-4 text-center">
//               {/* Simulated chat bubbles */}
//               <div className="flex flex-col space-y-3 w-full px-4">
//                 <div className="flex justify-start">
//                   <div className="bg-gray-300 animate-pulse rounded-2xl px-4 py-3 w-2/3 max-w-md"></div>
//                 </div>
//                 <div className="flex justify-end">
//                   <div className="bg-blue-300 animate-pulse rounded-2xl px-4 py-3 w-1/2 max-w-md"></div>
//                 </div>
//                 <div className="flex justify-start">
//                   <div className="bg-gray-300 animate-pulse rounded-2xl px-4 py-3 w-1/4 max-w-md"></div>
//                 </div>
//                 <div className="flex justify-end">
//                   <div className="bg-blue-300 animate-pulse rounded-2xl px-4 py-3 w-2/3 max-w-md"></div>
//                 </div>
//                 <div className="flex justify-start">
//                   <div className="bg-gray-300 animate-pulse rounded-2xl px-4 py-3 w-1/2 max-w-md"></div>
//                 </div>
//               </div>

//               {/* Optional loading indicator */}
//               <div className="text-gray-500 text-sm animate-pulse mt-4">
//                 Loading...
//               </div>
//             </div>
//           </div>
//         )}
//         {loading && nextCursor && (
//           // <div className="sticky top-0 z-10 py-2 px-4 bg-gray-100 space-y-3">
//           <div className="z-10 py-2 px-4 bg-gray-100 space-y-3">
//             <div className="flex justify-start">
//               <div className="bg-gray-300 animate-pulse rounded-2xl px-4 py-2 max-w-xs w-48 h-4"></div>
//             </div>
//             <div className="flex justify-end">
//               <div className="bg-blue-300 animate-pulse rounded-2xl px-4 py-2 max-w-xs w-40 h-4"></div>
//             </div>
//             <div className="flex justify-start">
//               <div className="bg-gray-300 animate-pulse rounded-2xl px-4 py-2 max-w-xs w-32 h-4"></div>
//             </div>
//             <div className="flex justify-end">
//               <div className="bg-blue-300 animate-pulse rounded-2xl px-4 py-2 max-w-xs w-44 h-4"></div>
//             </div>
//           </div>
//         )}

//         {groupedArray.map(([label, msgs], groupIdx) => (
//           <div key={label}>
//             <div className="text-center text-xs text-gray-500 my-2">
//               {label}
//             </div>
//             {msgs.map((msg, msgIdx) => {
//               const isOldest = groupIdx === 0 && msgIdx === 0;
//               return (
//                 <div
//                   key={msg.message_id}
//                   ref={isOldest ? topMessageRef : null}
//                   className={`flex ${
//                     msg.is_from_me ? "justify-end" : "justify-start"
//                   }`}
//                 >
//                   <div className="flex flex-col items-end mb-2 max-w-full">
//                     <div className="text-[10px] text-gray-500 mb-1">
//                       {formatTime(msg.timestamp)}
//                     </div>
//                     <div
//                       className={`rounded-3xl px-4 py-2 max-w-xs md:max-w-md lg:max-w-lg shadow-md text-sm break-words ${
//                         msg.is_from_me
//                           ? "bg-blue-500 text-white"
//                           : "bg-white border border-gray-200"
//                       }`}
//                     >
//                       {msg.body}
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         ))}
//       </div>

//       {/* Scroll to Bottom */}
//       {showScrollToBottom && (
//         <button
//           onClick={scrollToBottom}
//           className="absolute bottom-4 right-4 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-2 shadow-md z-50"
//           title="Scroll to bottom"
//         >
//           <ArrowDownCircle size={24} />
//         </button>
//       )}

//       {/* New Message Indicator */}
//       {showNewMessage && !showScrollToBottom && (
//         <div className="absolute bottom-16 right-4 z-50">
//           <button
//             onClick={scrollToBottom}
//             className="bg-yellow-300 hover:bg-yellow-400 text-black font-medium px-4 py-2 rounded-full shadow-md text-sm"
//           >
//             New message
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default MessagesPane;



// /* ------------------- Utility + Reusable ------------------- */
// // Autocomplete for property search
// const AutoCompleteInput = ({ value, onChange, fetchOptions, placeholder }) => {
//   const [query, setQuery] = useState(value?.name || "");
//   const [options, setOptions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);

//   const listRef = useRef(null);

//   const fetchDebounced = useMemo(
//     () =>
//       debounce(async (q, reset = true, pageNo = 1) => {
//         setLoading(true);
//         try {
//           const res = await fetchOptions(q, pageNo);
//           if (reset) {
//             setOptions(res.items || []);
//           } else {
//             setOptions((prev) => [...prev, ...(res.items || [])]);
//           }
//           setHasMore(res.pagination?.hasMore || false);
//         } catch (err) {
//           console.error("Autocomplete fetch error:", err);
//         } finally {
//           setLoading(false);
//         }
//       }, 400),
//     [fetchOptions]
//   );

//   useEffect(() => {
//     if (!query) {
//       setOptions([]);
//       return;
//     }
//     setPage(1);
//     fetchDebounced(query, true, 1);
//   }, [query]);

//   const handleScroll = () => {
//     if (!listRef.current || loading || !hasMore) return;
//     const { scrollTop, scrollHeight, clientHeight } = listRef.current;
//     if (scrollTop + clientHeight >= scrollHeight - 10) {
//       const nextPage = page + 1;
//       setPage(nextPage);
//       fetchDebounced(query, false, nextPage);
//     }
//   };

//   return (
//     <div className="relative w-full">
//       <input
//         value={query}
//         onChange={(e) => {
//           setQuery(e.target.value);
//           setShowDropdown(true);
//         }}
//         placeholder={placeholder}
//         className="border rounded px-3 py-2 w-full"
//       />
//       {loading && <div className="absolute top-full left-0 right-0 p-2 text-sm">Loading...</div>}
//       {showDropdown && options.length > 0 && (
//         <ul
//           ref={listRef}
//           onScroll={handleScroll}
//           className="absolute top-full left-0 right-0 bg-white border rounded shadow max-h-48 overflow-y-auto z-10"
//         >
//           {options.map((opt) => (
//             <li
//               key={opt.id}
//               className="px-3 py-2 hover:bg-blue-100 cursor-pointer"
//               onClick={() => {
//                 onChange(opt);
//                 setQuery(opt.name);
//                 setShowDropdown(false);
//               }}
//             >
//               {opt.name}
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// // Tour Links Modal
// const TourLinksModal = ({ threadId, isOpen, onClose, axiosInstance }) => {
//   const [links, setLinks] = useState([]);
//   const [selectedProperty, setSelectedProperty] = useState(null);
//   const [units, setUnits] = useState([]);
//   const [unitPage, setUnitPage] = useState(1);
//   const [hasMoreUnits, setHasMoreUnits] = useState(true);
//   const [selectedUnit, setSelectedUnit] = useState("");

//   useEffect(() => {
//     if (!isOpen) return;
//     const fetchLinks = async () => {
//       try {
//         const res = await axiosInstance.get(`/tour-links`, { params: { threadId } });
//         setLinks(res.data || []);
//       } catch (err) {
//         console.error("Failed to fetch tour links:", err);
//       }
//     };
//     fetchLinks();
//   }, [isOpen, threadId, axiosInstance]);

//   const searchProperties = async (q, page = 1) => {
//     const res = await axiosInstance.get(`/properties/search`, { params: { q, page, limit: 10 } });
//     return res.data;
//   };

//   const fetchUnits = async (propertyId, page = 1) => {
//     const res = await axiosInstance.get(`/properties/units`, {
//       params: { property_id: propertyId, page, limit: 10 },
//     });
//     return res.data;
//   };

//   useEffect(() => {
//     if (!selectedProperty) return;
//     setUnits([]);
//     setUnitPage(1);
//     setHasMoreUnits(true);
//     (async () => {
//       const res = await fetchUnits(selectedProperty.id, 1);
//       setUnits(res.items || []);
//       setHasMoreUnits(res.pagination?.hasMore || false);
//     })();
//   }, [selectedProperty]);

//   const handleUnitsScroll = (e) => {
//     if (!hasMoreUnits) return;
//     const { scrollTop, clientHeight, scrollHeight } = e.target;
//     if (scrollTop + clientHeight >= scrollHeight - 10) {
//       const next = unitPage + 1;
//       setUnitPage(next);
//       fetchUnits(selectedProperty.id, next).then((res) => {
//         setUnits((prev) => [...prev, ...(res.items || [])]);
//         setHasMoreUnits(res.pagination?.hasMore || false);
//       });
//     }
//   };

//   return isOpen ? (
//     <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
//       <div className="bg-white w-full max-w-lg rounded-lg shadow-lg p-6">
//         <h2 className="text-lg font-semibold mb-4">Tour Links</h2>

//         <AutoCompleteInput
//           value={selectedProperty}
//           onChange={setSelectedProperty}
//           fetchOptions={searchProperties}
//           placeholder="Search property..."
//         />

//         <div className=" rounded w-full max-h-40 overflow-y-auto mt-3" onScroll={handleUnitsScroll}>
//           {console.log("units",units)}
//           {units.map((u) => 
//             <div
//               key={u.id}
//               className={`px-3 py-2 cursor-pointer ${selectedUnit === u.id ? "bg-blue-100" : ""}`}
//               onClick={() => setSelectedUnit(u.id)}
//             >
//               {u?.model_name} - {u?.unit} - {u?.unit_details}
//             </div>
//           )}
//         </div>
//         <div className="flex justify-end">
//         <button className="rounded border px-4 py-2 text-sm hover:bg-gray-100" onClick={()=>{onClose()}}>Close</button>
//         </div>
//       </div>
//     </div>
//   ) : null;
// };

// /* ------------------- Main MessagesPane ------------------- */


// V2 - With toured link

import { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { format, isToday, isYesterday } from "date-fns";
import {
  SendHorizonal,
  ArrowDownCircle,
  RefreshCcw,
  Link2
} from "lucide-react";
import useAxiosInstance from "../../helpers/useAxiosInstance";
import { debounce } from "lodash";
import { getDisplayName } from "../../utils/message.utils";
import { TourLinksModal } from "../custom/TourLinksModal";
import CustomTruncate from "../custom/CustomTruncate";


const SkeletonLoader = () => (
  <div className="flex justify-start mb-3">
    <div className="bg-gray-300 animate-pulse rounded-3xl px-6 py-3 w-1/2 h-4" />
  </div>
);

const smoothScrollBy = (element, delta, duration = 1) => {
  const start = element.scrollTop;
  const startTime = performance.now();

  const animate = (currentTime) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = 0.5 * (1 - Math.cos(Math.PI * progress)); // ease-in-out

    element.scrollTop = start + delta * ease;

    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  };

  requestAnimationFrame(animate);
};

const MessagesPane = ({ contact }) => {
  const [messages, setMessages] = useState([]);
  const [nextCursor, setNextCursor] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [client, setClient] = useState(null);
  const [showScrollToBottom, setShowScrollToBottom] = useState(false);
  const [showNewMessage, setShowNewMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isTourModalOpen, setIsTourModalOpen] = useState(false);

  const axiosInstance = useAxiosInstance();
  const scrollRef = useRef(null);
  const topMessageRef = useRef(null);
  const observerRef = useRef(null);

  const scrollToBottom = () => {
    scrollRef.current?.scrollTo({
      top: scrollRef.current.scrollHeight,
      behavior: "smooth",
    });
    setShowNewMessage(false);
  };

  const fetchMessages = useCallback(
    async (cursor = null, replace = false) => {
      if (!contact?.thread_id || loading || (!replace && !hasMore)) return;

      setLoading(true);
      setErrorMessage("");

      try {
        const res = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}/messages/list`,
          {
            params: {
              threadId: contact.thread_id,
              limit: 20,
              cursor: cursor ?? undefined,
            },
          }
        );

        const newMessages = (res.data?.data || []).reverse();
        const newCursor = res.data?.pagination?.nextCursor ?? null;
        const more = res.data?.pagination?.hasMore ?? false;

        setMessages((prev) => {
          const existingIds = new Set(prev.map((m) => m.message_id));
          const uniqueNew = newMessages.filter(
            (msg) => !existingIds.has(msg.message_id)
          );
          return replace ? uniqueNew : [...uniqueNew, ...prev];
        });

        setNextCursor(newCursor);
        setHasMore(more);
      } catch (err) {
        console.error("Fetch messages error:", err);
        setErrorMessage("Failed to load messages. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [contact?.thread_id, axiosInstance, hasMore, loading]
  );

  // Debounce fetch to prevent rapid multiple calls
  const debouncedFetchMessages = useMemo(
    () =>
      debounce(
        (
          cursor,
          replace = false,
          container = null,
          topEl = null,
          oldTopOffset = 0
        ) => {
          fetchMessages(cursor, replace).then(() => {
            if (replace) {
              setTimeout(() => {
                scrollRef.current?.scrollTo({
                  top: scrollRef.current.scrollHeight,
                  behavior: "smooth",
                });
              }, 0);
            } else if (oldTopOffset > 0 && topMessageRef?.current) {
              setTimeout(() => {
                const newTopOffset = topEl?.offsetTop;
                const scrollAdjustment = newTopOffset - oldTopOffset;
                smoothScrollBy(container, scrollAdjustment);
              }, 0);
            }
          });
        },
        1000
      ),
    [fetchMessages, topMessageRef, smoothScrollBy]
  );

  useEffect(() => {
    if (!contact?.thread_id) return;

    setMessages([]);
    setNextCursor(null);
    setHasMore(true);
    setClient(contact?.client || null);

    debouncedFetchMessages(null, true);
  }, [contact]);

  const isNearBottom = () => {
    const el = scrollRef.current;
    if (!el) return false;
    return el.scrollHeight - el.scrollTop - el.clientHeight < 200;
  };

  const handleRefresh = async () => {
    const shouldScroll = isNearBottom();
    setErrorMessage("");
    setMessages([]);
    setNextCursor(null);
    setHasMore(true);
    setShowScrollToBottom(false);
    try {
      debouncedFetchMessages(null, true);

    } catch (err) {
      setErrorMessage("Failed to refresh messages.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    scrollRef.current?.scrollTo({
      top: 50,
      behavior: "smooth",
    });
    const container = scrollRef.current;
    const topEl = topMessageRef.current;

    if (!container || !topEl || loading || !hasMore || !nextCursor) return;

    const oldTopOffset = topEl.offsetTop;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && nextCursor) {
          console.log("Called");
          // Fetch and preserve scroll position
          debouncedFetchMessages(
            nextCursor,
            false,
            container,
            topEl,
            oldTopOffset
          );

        }
      },
      {
        root: container,
        threshold: 1.0,
      }
    );

    observer.observe(topEl);
    observerRef.current = observer;

    return () => observerRef.current.disconnect();
  }, [messages, nextCursor, hasMore, loading]);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const handleScroll = () => {
      const distanceFromBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight;
      setShowScrollToBottom(distanceFromBottom > 300);
    };

    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const isNearBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 200;

    if (!isNearBottom) {
      //setShowNewMessage(true);
    } else {
      //setShowNewMessage(false);
      scrollToBottom();
    }
  }, [messages.length]);

  const handleTextClick = (phoneNumber, name = "") => {
    const message = ``.trim();
    window.open(`sms:${phoneNumber}?body=${encodeURIComponent(message)}`);
  };

  const formatDateLabel = (timestamp) => {
    const date = new Date(timestamp);
    if (isToday(date)) return "Today";
    if (isYesterday(date)) return "Yesterday";
    return format(date, "MMM dd, yyyy");
  };

  const formatTime = (timestamp) => format(new Date(timestamp), "hh:mm a");

  const grouped = useMemo(
    () =>
      messages.reduce((acc, msg) => {
        const dateLabel = formatDateLabel(msg.timestamp);
        if (!acc[dateLabel]) acc[dateLabel] = [];
        acc[dateLabel].push(msg);
        return acc;
      }, {}),
    [messages]
  );
  const groupedArray = useMemo(() => Object.entries(grouped), [grouped]);

  return (
    <div className="flex flex-col flex-1 bg-gray-100 relative">
      {/* Header */}
      <div className="bg-white border-b px-6 py-3 shadow-sm font-semibold flex justify-between items-center">
        <div className="flex flex-col flex-1">
          <div>
            {getDisplayName(
              client,
              contact?.participants ?? [],
              contact?.contact
            )}{" "}
            {contact?.participants?.at(0) &&
              `(${contact?.participants?.at(0)})`}
          </div>
          <div className="flex flex-wrap gap-2 mt-2 text-xs font-normal">
            {contact?.client?.email && (
              <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
                ✉️ {contact?.client?.email}
              </span>
            )}
            {contact?.client?.budget && (
              <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full">
                💰 ${contact?.client?.budget}
              </span>
            )}

            {contact?.client?.no_of_bedrooms?.length > 0 && (
              <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">
                🛏️ {contact?.client?.no_of_bedrooms?.join(", ")}
              </span>
            )}
            {contact?.client?.move_in_date && (
              <span className="bg-pink-100 text-pink-700 px-2 py-1 rounded-full">
                🗓️ {format(new Date(contact?.client?.move_in_date), "MMM dd, yyyy")}
              </span>
            )}
            {contact?.client?.is_form && (
              <span className="bg-indigo-100 text-indigo-700 px-2 py-1 rounded-full">
                📝 Filled Form
              </span>
            )}
            {contact?.client?.desired_location && (
              <span className="bg-purple-100 text-purple-700 px-2 py-1 rounded-full">
                📍 <CustomTruncate text={contact?.client?.desired_location} />
              </span>
            )}
          </div>
        </div>
        <div className="flex flex-1 gap-2 justify-end self-start">
          <button
            className="flex items-center gap-1 px-2 py-1 border border-blue-500 text-blue-600 hover:text-white hover:bg-blue-500 rounded text-sm"
            onClick={() => setIsTourModalOpen(true)}
          >
            <Link2 size={16} />
            Link Toured Property
          </button>
          <button
            onClick={() => {
              handleRefresh();
            }}
            disabled={loading}
            className="flex items-center gap-1 px-2 py-1 border border-blue-500 text-blue-600 hover:text-white hover:bg-blue-500 rounded text-sm"
            title="Refresh"
          >
            <RefreshCcw size={16} />
          </button>
          <button
            onClick={() =>
              handleTextClick(contact?.participants?.[0], client?.firstname)
            }
            className="flex items-center gap-1 px-2 py-1 border border-blue-500 text-blue-600 hover:text-white hover:bg-blue-500 rounded text-sm"
          >
            <SendHorizonal size={16} />
          </button>
        </div>
      </div>

      {/* Tour Links Modal */}
      <TourLinksModal
        threadId={contact?.thread_id}
        isOpen={isTourModalOpen}
        onClose={() => setIsTourModalOpen(false)}
        axiosInstance={axiosInstance}
      />

      {/* Message List */}
      <div
        ref={scrollRef}
        className="flex-1 overflow-y-auto px-4 py-2 space-y-4 relative"
      >
        {/* <div ref={topMessageRef} className="h-1" /> */}

        {errorMessage && (
          <div className="text-red-600 text-sm text-center py-2">
            {errorMessage}
          </div>
        )}

        {loading && messages.length === 0 && (
          <div className="absolute inset-0 bg-white/70 backdrop-blur-sm z-10">
            {/* loader inside */}

            <div className="flex flex-col flex-1 justify-center items-center py-10 space-y-4 text-center">
              {/* Simulated chat bubbles */}
              <div className="flex flex-col space-y-3 w-full px-4">
                <div className="flex justify-start">
                  <div className="bg-gray-300 animate-pulse rounded-2xl px-4 py-3 w-2/3 max-w-md"></div>
                </div>
                <div className="flex justify-end">
                  <div className="bg-blue-300 animate-pulse rounded-2xl px-4 py-3 w-1/2 max-w-md"></div>
                </div>
                <div className="flex justify-start">
                  <div className="bg-gray-300 animate-pulse rounded-2xl px-4 py-3 w-1/4 max-w-md"></div>
                </div>
                <div className="flex justify-end">
                  <div className="bg-blue-300 animate-pulse rounded-2xl px-4 py-3 w-2/3 max-w-md"></div>
                </div>
                <div className="flex justify-start">
                  <div className="bg-gray-300 animate-pulse rounded-2xl px-4 py-3 w-1/2 max-w-md"></div>
                </div>
              </div>

              {/* Optional loading indicator */}
              <div className="text-gray-500 text-sm animate-pulse mt-4">
                Loading...
              </div>
            </div>
          </div>
        )}
        {loading && nextCursor && (
          // <div className="sticky top-0 z-10 py-2 px-4 bg-gray-100 space-y-3">
          <div className="z-10 py-2 px-4 bg-gray-100 space-y-3">
            <div className="flex justify-start">
              <div className="bg-gray-300 animate-pulse rounded-2xl px-4 py-2 max-w-xs w-48 h-4"></div>
            </div>
            <div className="flex justify-end">
              <div className="bg-blue-300 animate-pulse rounded-2xl px-4 py-2 max-w-xs w-40 h-4"></div>
            </div>
            <div className="flex justify-start">
              <div className="bg-gray-300 animate-pulse rounded-2xl px-4 py-2 max-w-xs w-32 h-4"></div>
            </div>
            <div className="flex justify-end">
              <div className="bg-blue-300 animate-pulse rounded-2xl px-4 py-2 max-w-xs w-44 h-4"></div>
            </div>
          </div>
        )}

        {groupedArray.map(([label, msgs], groupIdx) => (
          <div key={label}>
            <div className="text-center text-xs text-gray-500 my-2">
              {label}
            </div>
            {msgs.map((msg, msgIdx) => {
              const isOldest = groupIdx === 0 && msgIdx === 0;
              return (
                <div
                  key={msg.message_id}
                  ref={isOldest ? topMessageRef : null}
                  className={`flex ${
                    msg.is_from_me ? "justify-end" : "justify-start"
                  }`}
                >
                  <div className="flex flex-col items-end mb-2 max-w-full">
                    <div className="text-[10px] text-gray-500 mb-1">
                      {formatTime(msg.timestamp)}
                    </div>
                    <div
                      className={`rounded-3xl px-4 py-2 max-w-xs md:max-w-md lg:max-w-lg shadow-md text-sm break-words ${
                        msg.is_from_me
                          ? "bg-blue-500 text-white"
                          : "bg-white border border-gray-200"
                      }`}
                    >
                      {msg.body}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Scroll to Bottom */}
      {showScrollToBottom && (
        <button
          onClick={scrollToBottom}
          className="absolute bottom-4 right-4 bg-blue-600 hover:bg-blue-700 text-white rounded-full p-2 shadow-md z-50"
          title="Scroll to bottom"
        >
          <ArrowDownCircle size={24} />
        </button>
      )}

      {/* New Message Indicator */}
      {showNewMessage && !showScrollToBottom && (
        <div className="absolute bottom-16 right-4 z-50">
          <button
            onClick={scrollToBottom}
            className="bg-yellow-300 hover:bg-yellow-400 text-black font-medium px-4 py-2 rounded-full shadow-md text-sm"
          >
            New message
          </button>
        </div>
      )}
    </div>
  );
};

export default MessagesPane;
